import React from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { CONFIGURATION as MUI_THEME_CONFIGURATION } from '../resources/Constants/MuiTheme'
import Routes from './routes'
import { useUserData } from './Helpers/useUserData'

//import context
import CMSProvider from './Components/CMS/CMSContext'
import MenuSectionProvider from './Components/CMS/MenuSection/MenuSectionContext'
import ErrorModalProvider from './Components/Shared/ErrorSnackBar/ErrorSnackBarContext'

const theme = createTheme(MUI_THEME_CONFIGURATION)

/**
 * Application entry point.
 * Maps provider, store, routes
 *
 * We are using browser router, if hashRouting is preferred then this is where you change.
 */

const App = () => {
  const { user, skipedLogin } = useUserData()
  return (
    (user || skipedLogin) && (
      <ThemeProvider theme={theme}>
        <CMSProvider>
          <MenuSectionProvider>
            <ErrorModalProvider>
              <Router>
                <Routes />
              </Router>
            </ErrorModalProvider>
          </MenuSectionProvider>
        </CMSProvider>
      </ThemeProvider>
    )
  )
}

export default App

App.propTypes = {
  MUI_THEME_CONFIGURATION: PropTypes.shape({
    breakpoints: PropTypes.shape({
      values: PropTypes.shape({
        xs: PropTypes.number.isRequired,
        sm: PropTypes.number.isRequired,
        md: PropTypes.number.isRequired,
        lg: PropTypes.number.isRequired,
        xl: PropTypes.number.isRequired
      })
    }),
    typography: PropTypes.object,
    props: PropTypes.object
  })
}
